import { render, staticRenderFns } from "./PriceDetailsPopin.vue?vue&type=template&id=8c3bccca&scoped=true"
import script from "./PriceDetailsPopin.vue?vue&type=script&lang=ts"
export * from "./PriceDetailsPopin.vue?vue&type=script&lang=ts"
import style0 from "./PriceDetailsPopin.vue?vue&type=style&index=0&id=8c3bccca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3bccca",
  null
  
)

export default component.exports